module.exports = __webpack_public_path__ + "static/media/tp_link_archer_23.7fc9d339.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/tp_link_archer_23.png
// module id = 988
// module chunks = 0